// 采购询价tabs
export const waitFeedbackEnquiryTabs = [
  { title: '待处理任务', name: '待处理任务' },
  { title: '我的待处理', name: '我的待处理' },
  { title: '我的已处理', name: '我的已处理' }
]

export const planListTabs = [
  { title: '待采购', name: '待采购' },
  { title: '采购审核', name: '采购审核' },
  { title: '采购中', name: '采购中' },
  { title: '已采购', name: '已采购' }
]
export const planListTabsReturn = [
  { title: '待制定退货任务产品', name: '待制定退货任务产品' },
  { title: '进行中退货任务', name: '进行中退货任务' },
  { title: '已完成退货任务', name: '已完成退货任务' }
]
// 采购询价搜索条件
export const waitFeedbackEnquiryList = [
  { label: '品类', value: 'pcName' },
  { label: '品牌', value: 'brandName' },
  { label: '系列', value: 'seriesName' },
  { label: '产品名称', value: 'proName' },
  { label: '型号', value: 'proType' },
  { label: '订货号', value: 'orderNumber' },
  // { label: '类型', value: 'ocExtype' },
  { label: '货期', value: 'ocExtime' },
  { label: '数量', value: 'ocNeednumber' },
  { label: '产品状态', value: 'isOnline' },
  { label: '提交人', value: 'createUser' },
  { label: '提交时间', value: 'createDate' },
  { label: '认领人', value: 'staffCnName' },
  { label: '认领时间', value: 'processDate' }
]
// 采购询价搜索条件
export const returnTaskListNow = [
  { label: '退回任务编号', value: '11111' },
  { label: '关联采购合同', value: '22222' },
  { label: '供应商', value: '33333' },
  { label: '退货品牌', value: '44444' },
  { label: '退货状态', value: '55555' },
  { label: '申请人', value: '66666' },
  { label: '请求退货时间', value: '77777' },
  { label: '认领人', value: '88888' },
  { label: '认领时间', value: '99999' }

]
// 采购询价搜索条件我的待处理
export const waitFeedbackEnquiryListWait = [
  { label: '品类', value: 'pcName' },
  { label: '品牌', value: 'brandName' },
  { label: '系列', value: 'seriesName' },
  { label: '产品名称', value: 'proName' },
  { label: '型号', value: 'proType' },
  { label: '订货号', value: 'orderNumber' },
  // { label: '类型', value: 'ocExtype' },
  { label: '货期', value: 'ocExtime' },
  { label: '数量', value: 'ocNeednumber' },
  { label: '产品状态', value: 'isOnline' },
  { label: '提交人', value: 'createUser' },
  { label: '提交时间', value: 'createDate' },
  { label: '认领时间', value: 'processDate' }
]
// 采购询价搜索条件我的已处理
export const waitFeedbackEnquiryListMy = [
  { label: '品类', value: 'pcName' },
  { label: '品牌', value: 'brandName' },
  { label: '系列', value: 'seriesName' },
  { label: '产品名称', value: 'proName' },
  { label: '型号', value: 'proType' },
  { label: '订货号', value: 'orderNumber' },
  // { label: '类型', value: 'ocExtype' },
  { label: '货期', value: 'ocExtime' },
  { label: '数量', value: 'ocNeednumber' },
  { label: '产品状态', value: 'isOnline' },
  { label: '提交人', value: 'createUser' },
  { label: '提交时间', value: 'createDate' },
  { label: '处理时间', value: 'updateDate' }
]
// 合同列表筛选条件
export const contractScreenCondition = [
  { label: '合同编号', value: 'pcbNumber' },
  { label: '客户名称', value: '客户名称' },
  { label: '付款类型', value: '付款类型' },
  { label: '合同金额', value: '合同金额' },
  { label: '发货状态', value: '发货状态' },
  { label: '开票状态', value: '开票状态' },
  { label: '签订时间', value: '签订时间' }
]
export const contractScreenConditionList = [
  { label: '合同编号', value: 'pcbNumber' },
  { label: '供应商合同编号', value: 'supplierContractNumber' },
  { label: '供应商名称', value: 'suName' },
  { label: '付款类型', value: 'payType' },
  { label: '合同金额', value: 'purchaseTotal' },
  { label: '合同状态', value: 'contractState' },
  { label: '发货状态', value: 'deliverState' },
  { label: '收票状态', value: 'invoiceState' },
  { label: '签订时间', value: 'createDate' },
  { label: '型号', value: 'proModel' },
  { label: '订货号', value: 'proNumber' }
]
// 采购备货区tabs
export const purchasingStockAreaList = [
  { title: '合并计划', name: '合并计划' },
  { title: '品牌拆分', name: '品牌拆分' },
  { title: '供应商拆分', name: '供应商拆分' }
]
// 采购合同列表tabs状态
export const contractListTabs = [
  { title: '全部', name: '全部' },
  { title: '待签署', name: '待签署' },
  { title: '履行中', name: '履行中' },
  { title: '已履行', name: '已履行' },
  { title: '已作废', name: '已作废' }
]
// 付款类型
export const paymentTypeList = [
  { label: '约定账期', value: '约定账期' },
  { label: '全款发货', value: '全款发货' },
  { label: '先货后款', value: '先货后款' }
]
// 质保期限
export const deadlineList = [
  { label: '1个月', value: '1个月' },
  { label: '2个月', value: '2个月' },
  { label: '3个月', value: '3个月' },
  { label: '6个月', value: '6个月' },
  { label: '12个月', value: '12个月' },
  { label: '18个月', value: '18个月' },
  { label: '24个月', value: '24个月' }
]
// 采购已履行合同详情tabs
export const contractDetailsTabs = [
  { title: '账务信息', name: '账务信息' },
  { title: '产品清单', name: '产品清单' },
  { title: '退货产品', name: '退货产品' },
  { title: '发货管理', name: '发货管理' },
  { title: '票据管理', name: '票据管理' },
  { title: '售后管理', name: '售后管理' },
  { title: '任务列表', name: '任务列表' },
  { title: '相关附件', name: '相关附件' }
]
// 已履行合同详情产品清单tabs
export const productListTabs = [
  { title: '产品清单', name: '产品清单' },
  { title: '报缺产品', name: '报缺产品' }
]
// 采购发货记录tabs状态
export const deliveryRecordTabs = [
  { title: '全部', name: '全部' },
  { title: '已发货', name: '已发货' },
  { title: '物流在途', name: '物流在途' },
  { title: '已入库', name: '已入库' }
]
// 待付款供应商列表Tabs
export const toBePaidTabs = [
  { title: '待付款供应商列表', name: '待付款供应商列表' },
  { title: '付款记录', name: '付款记录' }
]
